import React, { useState } from 'react'
import './Contact.css'
function Contact() {


    const [formData, setFormData] = useState({
        name: "",
        email: "",
        topic: "",
        message: ""
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault(); // Prevent default form submission

        const { name, email, topic, message } = formData;

        // Construct mailto link
        const mailtoLink = `mailto:nedh.saouira@mhai.gov.ma?subject=${encodeURIComponent(topic)}&body=${encodeURIComponent(
            `الإسم: ${name}\nالبريد الإلكتروني: ${email}\n\n${message}`
        )}`;

        // Open default email client
        window.location.href = mailtoLink;
    };



    return (
        <div id='Contact' className='Contact'>
            <br></br><br></br>
            <div className='contact-content'>

                <div className='form-content' >
                    <h4>تواصل معنا</h4>
                    <div className='form'>
                        <form onSubmit={handleSubmit} className="contact-form">
                            <input type="text" name="name" placeholder="الإسم" value={formData.name} onChange={handleChange} required /><br />
                            <input type="email" name="email" placeholder="البريد الإلكتروني" value={formData.email} onChange={handleChange} required /><br />
                            <input type="text" name="topic" placeholder="الموضوع" value={formData.topic} onChange={handleChange} required /><br />
                            <textarea name="message" placeholder="اكتب رسالتك هنا" value={formData.message} onChange={handleChange} required></textarea><br />
                            <button type="submit" className="button">إرسال</button>
                        </form>
                    </div>  
                </div>

                <div className='map-content'>
                    <div className='adresse'>
                        شارع بوشعيب الدكالي رقم 77 الصويرة <br></br>
                        الهاتف :  258 85 05247 <br></br>
                        nedh.saouira@mhai.gov.ma <br></br>
                    </div>
                    <div className='map'>
                        <br></br>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3402.184795558481!2d-9.763698999999999!3d31.491604000000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzHCsDI5JzI5LjgiTiA5wrA0NSc0OS4zIlc!5e0!3m2!1sfr!2sma!4v1742567100877!5m2!1sfr!2sma" title='map' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
                <br></br><br></br>


            </div>
        </div>
    )
}

export default Contact